// extracted by mini-css-extract-plugin
export default {"tipsscreen-titles":"TipsScreen_tipsscreen-titles__AomE4","tipsscreen-container":"TipsScreen_tipsscreen-container__sgaXe"};